// Global app entry point.
// Block-specific JS lives in blocks/{name}/script.js

import './matomo-events';
